module.exports = __webpack_public_path__ + "img/solmet.15e11590.png";